module.exports = __webpack_public_path__ + "img/holiday-tractor.b1f471ff.jpg";